import { BaseResource } from 'e100-data-providers';
import { TRestProvider } from 'dataSources/types/restProvider';
import {
  IStationInfoResponse,
  IStationsResponse,
  IStationCodesResponse,
  IStationPricesResponse,
} from './types';
import { EMPTY_STRING } from 'common/constants';

import mappingFilter from './utils/mappingFilter';
import { FilterParams } from 'dataServices/stations/types/initStations';

export * from './types';

class Stations extends BaseResource {
  path: string = EMPTY_STRING;

  constructor(provider: TRestProvider) {
    super(provider);
    this.path = 'stations';
  }

  getStations({
    fullCardNumber,
  }: {
    fullCardNumber?: string;
  }): Promise<IStationsResponse> {
    return this.send(
      this.request.post().setBody({
        ...(fullCardNumber && { fullCardNumber: fullCardNumber }),
      }),
    );
  }

  getStationCodes(filter: FilterParams): Promise<IStationCodesResponse> {
    return this.send(
      this.request.post('search').setBody(mappingFilter(filter)),
    );
  }

  getStationInfo(code: string): Promise<IStationInfoResponse> {
    return this.getChildResource(code).getItems();
  }

  getStationPrices({
    stationCode,
    cardNumber,
  }: {
    stationCode: string;
    cardNumber?: string;
  }): Promise<IStationPricesResponse> {
    let str = `${stationCode}/prices`;

    if (cardNumber) {
      str += `?fullCardNumber=${cardNumber}`;
    }

    return this.getChildResource(str).getItems();
  }
}

export default Stations;
